import { useQuery } from "@tanstack/react-query";
import { useSearchParams } from "../../../../hook/use-search-params";
import { DocumentService } from "../../../../services/document/document.service";

export const useDocumentByStatus = () => {
  const { searchParams } = useSearchParams();
  const status = searchParams.get("status") || "";

  const { data, isLoading } = useQuery({
    queryKey: ["document-by-status", status],
    queryFn: () => DocumentService.getWorkingDocuments("", status),
    enabled: status === "compose" || status === "approval",
  });

  const boxText =
    status === "compose" ? "Tài liệu đang soạn thảo" : status === "approval" ? "Tài liệu cần duyệt" : "";

  return { data, isLoading, boxText };
};
